(function () {
  document.querySelectorAll('[data-bc-selection-hide-at]').forEach(function (subtitle) {
    const hideAt = Date.parse(subtitle.dataset.bcSelectionHideAt);
    if (!Number.isFinite(hideAt)) return;

    function updateVisibility() {
      const remaining = hideAt - Date.now();
      subtitle.hidden = remaining <= 0;
      if (remaining > 0) {
        window.setTimeout(updateVisibility, Math.min(remaining, 2147483647));
      }
    }

    updateVisibility();
  });
})();
